import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\GetMessageTextListController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextListController.php
* @route '/api/message-text'
*/
const GetMessageTextListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMessageTextListController.url(options),
    method: 'get',
})

GetMessageTextListController.definition = {
    methods: ["get","head"],
    url: '/api/message-text',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextListController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextListController.php
* @route '/api/message-text'
*/
GetMessageTextListController.url = (options?: RouteQueryOptions) => {
    return GetMessageTextListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextListController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextListController.php
* @route '/api/message-text'
*/
GetMessageTextListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMessageTextListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MessageText\GetMessageTextListController::__invoke
* @see app/Http/Controllers/MessageText/GetMessageTextListController.php
* @route '/api/message-text'
*/
GetMessageTextListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMessageTextListController.url(options),
    method: 'head',
})

export default GetMessageTextListController